import api from "./axios";

export const getPurchaseHistory = async (
  limit: number,
  start: number,
  start_time: string,
  end_time: string
) => {
  return await api.get("/api/web-api/get-purchase-history", {
    params: {
      limit: limit,
      start: start,
      start_time: start_time,
      end_time: end_time,
    },
  });
};
